export default "__VITE_ASSET__CBDDRu6S__"